import React from 'react'
import { Box, Container } from '@mui/material'
import SignIn from './sign-in/SignIn'

const MUISignIn = ({ onAuthStateChange }) => {
  return (
    <Container maxWidth='sm'>
      <Box
        sx={{
          backgroundColor: '#fff',
          minHeight: '70vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          py: 4,
          color: '#556cd6',
          '& .MuiTypography-root': {
            color: '#556cd6',
          },
          '& .MuiInputLabel-root': {
            color: '#grey',
          },
          '& .MuiLink-root': {
            color: '#grey',
          },
        }}
      >
        <SignIn onAuthStateChange={onAuthStateChange} />
      </Box>
    </Container>
  )
}

export default MUISignIn
